import * as React from 'react';
import { Subject } from '@packages/common';

import { Carousel, Slides, CarouselProps } from '../Carousel';
import { ProductCarouselWrapper } from '../ProductCarouselWrapper';
import {
  ProductCarouselImpressionTracker,
  ProductCarouselImpressionTrackerProps,
} from '../ProductCarouselImpressionTracker';
import { RecommendationChannel } from '../../containers';

export const PRODUCT_CAROUSEL_SLIDES_TO_SHOW = [2, 3, 4, 4, 5];
const MIN_SLIDES_THRESHOLD = 4;

interface ProductCarouselProps
  extends Omit<CarouselProps, 'afterSlide' | 'slidesToShow'>,
    Omit<ProductCarouselImpressionTrackerProps, 'onAfterSlideSubject' | 'channel'> {
  title?: string;
  recommendationChannel?: RecommendationChannel;
  slidesToShow?: number[];
  /**
   * doesnt render the carousel if there is not enough slides
   */
  minSlidesThreshold?: number;
}

export const ProductCarousel: React.FC<ProductCarouselProps> = ({
  recommendationChannel,
  isSorted,
  categoryId,
  title,
  slides,
  breakpoints,
  minSlidesThreshold = MIN_SLIDES_THRESHOLD,
  slidesToShow = PRODUCT_CAROUSEL_SLIDES_TO_SHOW,
}) => {
  const onAfterSlideSubject = React.useRef(new Subject<number[]>([]));
  if (minSlidesThreshold >= slides.length) {
    return <></>;
  }

  return (
    <Carousel
      afterSlide={(_, visibleIndexes) => onAfterSlideSubject.current.next(visibleIndexes)}
      initialIndex={0}
      slides={slides}
      slidesToShow={slidesToShow}
      centered={[true, true, false]}
      breakpoints={breakpoints}
    >
      <ProductCarouselImpressionTracker
        categoryId={categoryId}
        recommendationChannel={recommendationChannel}
        isSorted={isSorted}
        onAfterSlideSubject={onAfterSlideSubject.current}
      >
        <ProductCarouselWrapper title={title}>
          <Slides />
        </ProductCarouselWrapper>
      </ProductCarouselImpressionTracker>
    </Carousel>
  );
};
